module.exports = __webpack_public_path__ + "static/img/dianshiji.5845795c.svg";